import Image from "next/image";
import Link from "next/link";
import { useWindowSize } from "usehooks-ts";

import useLayoutStore from "@/store/useLayoutStore";

import logoBrand from "@/assets/myconnect-logo128.png";
import { PAGE_URL } from "@/utils/constants";

const BrandLogo = ({
  className,
  disableHref,
}: {
  className?: string;
  disableHref?: boolean;
}) => {
  const collapsed = useLayoutStore.useCollapsed();
  const { width } = useWindowSize();

  if (!disableHref)
    return (
      <Link
        href={PAGE_URL.dashboard}
        className={`font-semibold text-gray-100 text-xl leading-none px-6 font-body flex items-center ${className}`}
      >
        <Image
          src={logoBrand}
          alt="image cover"
          height={28}
          className={`inline-block ${width > 768 ? !collapsed && "mr-2" : "mr-2"}`}
        />
      </Link>
    );

  if (disableHref)
    return (
      <div
        className={`font-semibold text-gray-100 text-xl leading-none px-2 font-body flex items-center ${className}`}
      >
        <Image
          src={logoBrand}
          alt="image cover"
          height={28}
          className={`inline-block ${width > 768 ? !collapsed && "mr-2" : "mr-2"}`}
        />
      </div>
    );
};

export default BrandLogo;
